import React, { useState, useEffect } from 'react';
import axios from 'axios';

function ResetPassword({ onNavigateToLogin }) {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);
    const [params, setParams] = useState({ id: '', token: '' });

    useEffect(() => {
        // Parse URL parameters manually since we aren't using React Router
        const searchParams = new URLSearchParams(window.location.search);
        const id = searchParams.get('id');
        const token = searchParams.get('token');

        if (id && token) {
            setParams({ id, token });
        } else {
            setMessage('Invalid reset link.');
        }
    }, []);

    const handleReset = async () => {
        if (newPassword !== confirmPassword) {
            setMessage('Passwords do not match.');
            return;
        }
        if (newPassword.length < 6) {
            setMessage('Password must be at least 6 characters.');
            return;
        }

        try {
            const response = await axios.post(process.env.REACT_APP_API_URL + '/auth/reset-password', {
                id: params.id,
                token: params.token,
                newPassword
            });

            setMessage(response.data.message);
            setIsSuccess(true);

            // Optional: Clear URL params to clean up address bar
            window.history.replaceState({}, document.title, window.location.pathname);

        } catch (error) {
            setMessage(error.response?.data?.message || 'Failed to reset password.');
        }
    };

    if (!params.id || !params.token) {
        return (
            <div className="auth-form">
                <h3 style={{ textAlign: 'center', marginBottom: '1.5rem', color: '#374151' }}>
                    Reset Password
                </h3>
                <div className="message error">Invalid or missing reset link.</div>
                <button onClick={onNavigateToLogin} className="btn btn-primary w-100P" style={{ marginTop: '1rem' }}>
                    Back to Login
                </button>
            </div>
        );
    }

    return (
        <div className="auth-form">
            <h3 style={{ textAlign: 'center', marginBottom: '1.5rem', color: '#374151' }}>
                Reset Password
            </h3>

            {!isSuccess ? (
                <>
                    <div className="form-group">
                        <label className="form-label">New Password</label>
                        <input
                            type="password"
                            className="form-input"
                            placeholder="Enter new password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                        />
                    </div>

                    <div className="form-group">
                        <label className="form-label">Confirm Password</label>
                        <input
                            type="password"
                            className="form-input"
                            placeholder="Confirm new password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                    </div>

                    <button onClick={handleReset} className="btn btn-primary w-100P">
                        Reset Password
                    </button>
                </>
            ) : (
                <button onClick={onNavigateToLogin} className="btn btn-primary w-100P">
                    Login with New Password
                </button>
            )}

            {message && (
                <div className={`message ${message.includes('success') || isSuccess ? 'success' : 'error'}`} style={{ marginTop: '1rem' }}>
                    {message}
                </div>
            )}
        </div>
    );
}

export default ResetPassword;
